import { ChatPage } from '../../utils/chatPage';
import ChannelList from '../ChannelList';
import SingleChannelView from '../SingleChannelView';

const chatPageConfig = {
  [ChatPage.ChannelList]: {
    component: ChannelList,
    props: {},
  },
  [ChatPage.SingleChannelView]: {
    component: SingleChannelView,
    props: {},
  },
};

export {
  chatPageConfig,
};
